// extracted by mini-css-extract-plugin
module.exports = {"appStoreLinks":"StoreLinks_appStoreLinks__q2DWE","rating":"StoreLinks_rating__tC_DW"};